@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex w-full mb-3"
      [ngClass]="field.browserOpts.inLineWithCaption ? 'flex-row items-center' : 'flex-col'">
      <div [ngClass]="field.browserOpts.inLineWithCaption ? 'mr-2' : ''">
        <div class="leading-6 font-medium">{{ field.label | localize }}@if (field.required) {
          <span> *</span>
        }</div>
        @if (field.hint) {
          <div class="text-md text-secondary">{{ field.hint | localize }}</div>
        }
      </div>
      <div class="flex flex-col">
        <div class="flex flex-row w-full items-center">
          <timepicker-autofill-component [control]="field.control" [hourStep]="hourStep" [minuteStep]="minuteStep" [secondStep]="secondStep"
          [allowManual]="allowManual" [style]="style"></timepicker-autofill-component>
          @if (!field.required) {
            <button class="ml-2" mat-icon-button (click)="clear()">
              <mat-icon class="icon-size-5" svgIcon="heroicons_outline:x"></mat-icon>
            </button>
          }
        </div>
        @if (!field.readonly &&
          field.control.touched &&
          field.control.errors) {
          @if (field.control.hasError('required')) {
            <div class="text-sm text-warn leading-none font-medium">
              {{ 'timeRequired' | transloco }}
            </div>
          }
          @if (field.control.hasError('timeMax')) {
            <div class="text-sm text-warn leading-none font-medium mt-2">
              {{ 'timeLessThan' | transloco:{ time: max } }}
            </div>
          }
          @if (field.control.hasError('timeMin')) {
            <div class="text-sm text-warn leading-none font-medium mt-2">
              {{ 'timeGreaterThan' | transloco:{ time: min } }}
            </div>
          }
        }
      </div>
    </div>
  }
} @else {
  @if (field.control.value?.includes('T')) {
    @switch (style) {
      @case ('HH:mm') {
        {{ field.control.value | date:'HH:mm' }}
      }
      @case ('HH:mm:ss') {
        {{ field.control.value | date:'HH:mm:ss' }}
      }
    }
  } @else {
    {{ field.control.value }}
  }
}

